var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodTray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1686551177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4076 19.9585C9.01436 19.9585 7.88672 21.0861 7.88672 22.4794C7.88672 23.8726 9.01436 25.0002 10.4076 25.0002C11.7967 25.0002 12.9243 23.8726 12.9284 22.4794C12.9284 21.0861 11.8008 19.9585 10.4076 19.9585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.4902 19.9712C18.1052 20.1101 17.096 21.344 17.2308 22.725C17.3697 24.11 18.5995 25.1233 19.9846 24.9843C21.3696 24.8454 22.3829 23.6116 22.2439 22.2306C22.105 20.8456 20.8712 19.8323 19.4902 19.9712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.9808 3.86914H6.10399L5.85476 2.28799C5.65048 0.968316 4.51058 -0.00407284 3.17456 1.28269e-05H0.445338C0.200198 1.28269e-05 0 0.20021 0 0.445351C0 0.690491 0.200198 0.890688 0.445338 0.890688H3.17048C4.06932 0.890688 4.83334 1.54031 4.96817 2.4269L7.1254 16.0567C7.32969 17.3764 8.46959 18.3528 9.8056 18.3447H23.1412C23.3864 18.3447 23.5866 18.1445 23.5866 17.8993C23.5866 17.6542 23.3864 17.454 23.1412 17.454H9.80969C8.91084 17.454 8.14682 16.8044 8.01199 15.9178L7.64428 13.6012H21.3027C22.4589 13.6012 23.4885 12.8699 23.8685 11.7749L26.4016 4.46156C26.4506 4.32673 26.4261 4.17556 26.3444 4.05708C26.2586 3.9386 26.1238 3.86914 25.9808 3.86914ZM15.2314 9.15191H13.3683V11.015H12.4409V9.15191H10.5901V8.22446H12.4409V6.37365H13.3683V8.22446H15.2314V9.15191ZM20.269 9.23362H17.8258V8.2408H20.269V9.23362Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodTray);
export default __webpack_public_path__ + "static/media/foodTray.6fa3e64103ea2ac6e0e3a2cb5b1c4da2.svg";
export { ForwardRef as ReactComponent };